import * as z from "zod";

import { ReferrerSummarySchema } from "../shared/referrer";

export const impersonationExchange = {
  name: "impersonationExchange" as const,
  input: z.object({ code: z.string().min(1).max(512) }),
  output: z.object({
    referrer: ReferrerSummarySchema,
    authToken: z.string().min(1),
    expiresAt: z.iso.datetime(),
  }),
};
